import { render, staticRenderFns } from "./MWC.vue?vue&type=template&id=868c8810&scoped=true&"
import script from "./MWC.vue?vue&type=script&lang=js&"
export * from "./MWC.vue?vue&type=script&lang=js&"
import style0 from "./MWC.vue?vue&type=style&index=0&id=868c8810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c8810",
  null
  
)

export default component.exports